import { useDispatch, useSelector } from "react-redux";
import { addItem, clearPackage, removeItem, selectCurrentPackageItems, selectedNewPackageTitleData, selectPackageDetailsAction } from "../../features/package/packageSlice";
import { Product, ProductBaseOnCategory } from "../../types/product";
import { ProductPackage } from "../../types/package";
// import { setSelectedProduct } from "../../features/product/productSlice";
import { showToast } from "../../toastify/Toast";

export function useNewPackageManager() {
    const dispatch = useDispatch();
    const newPackageTitleData = useSelector(selectedNewPackageTitleData);
    const currentPackageItems = useSelector(selectCurrentPackageItems);
    const packageDetailAction = useSelector(selectPackageDetailsAction);
    const isSpecial = packageDetailAction.packageType === 'special'

    const handleAddProductToPackage = (prod: ProductBaseOnCategory) => {
        // console.log("prod: ", prod)
        // console.log("packageDetailAction: ", packageDetailAction)

        if (isSpecial) {
            if (!newPackageTitleData.packageName || !newPackageTitleData.totalValue) {
                    showToast("Please set package name and amount.", "info");
                    return;
            }
        } else {
            if (
                !newPackageTitleData.packageName ||
                !newPackageTitleData.quantity ||
                !newPackageTitleData.totalValue
            ) {
                showToast("Please set package name, cups, and amount.", "info");
                return;
            }
        }


        const existingItem = currentPackageItems?.find(
            (item: any) =>
                item.productId === prod.productID &&
                item.productSize === prod.sizeInfo.size &&
                item.productCategory === prod.categoryInfo.categoryName
        );

        if (existingItem) {
            dispatch(removeItem({ productId: existingItem.productId }));
            return;
        }

        const product: Product = {
            productID: prod.productID,
            productName: prod.productName ?? "",
            description: prod.description,
            price: prod.price,
            sizeInfo: prod.sizeInfo,
            image: prod.image ?? "",
            isAvailable: prod.isAvailable,
            categoryInfo: prod.categoryInfo,
            sizeId: prod.sizeInfo.sizeId,
        };

        const packageItem: ProductPackage = {
            productId: prod.productID,
            productName: prod.productName ?? "",
            productCategory: prod.categoryInfo.categoryName,
            productSize: prod.sizeInfo.size,
            productPrice: prod.price,
            addons: prod.addons ?? [],
            productType: prod.typeInfo.typeName,
            typeOfAdd: 'new',
        };

        // dispatch(setSelectedProduct(product));
        dispatch(addItem(packageItem));
    };

    const handleRemoveProduct = (productId: number) => {
        if (!productId) return;
        dispatch(removeItem({ productId }));
    };

    const resetPackage = () => {
        dispatch(clearPackage());
    };

    return {
        handleAddProductToPackage,
        handleRemoveProduct,
        resetPackage,
    };
}